import { getTheme } from "@ane/ui-components/lib/Styling";
const GarConstants = {
  SCORECARDS_PIVOT: "scorecards",
  ALERTS_PIVOT: "alerts",
  INSIGHTS_PIVOT: "insights",
  TRUSTWORTHY_PIVOT: "trustworthiness",
  METRIC_MOVEMENTS_PIVOT: "metric movements",
  EXTENSIONS_PIVOT: "extensions",
  ABSTRACT_PIVOT: "abstract",
  CATAPULT_PIVOT: "catapult",
  SET_PARTIAL_USER_CONTEXT: "Gar/SET_PARTIAL_USER_CONTEXT",
  SET_USER_CONTEXT: "Gar/SET_USER_CONTEXT",
  SEGMENT_AGGREGATE_NONE: "**NONE**",
  SEGMENT_AGGREGATE: "AGGREGATE",
  METRIC_CATEGORIES: ["DataQuality", "ProductWideImpact", "Guardrail", "Hypothesis"],
  HIGHLYSTATSIG_PVALTHRESHOLD: 1e-3,
  STATSIG_PVALTHRESHOLD: 0.05,
  METRICTHRESHOLD_DENOMINATORCOUNT: 100,
  MSFT_WORKSPACE_ID: "a5766fee-9478-488b-9fc0-64d1ad72c290",
  XBOX_WORKSPACE_ID: "3e3b8347-c494-4f7e-a5aa-3e693ba7dd3c",
  BING_WORKSPACE_ID: "f38e815f-79eb-4d78-8a05-2dff4e55453f",
  OPG_WORKSPACE_ID: "13273047-d2c3-4185-9022-76fc5fc6742a",
  MSFT_FEATURE_ID: "a5836d5f-88bb-4a01-940d-af16285fbbdb",
  OTHER_STRONG_MOVEMENTS: "Other Strong Movements",
  GUARDRAIL: "Guardrail",
  PRODUCT_WIDE_IMPACT: "Product-Wide Impact",
  DATA_QUALITY: "Data Quality",
  HYPOTHESIS: "Hypothesis",
  EXCLUDED_METRIC_NAMES: ["QCNT", "MaxQueryTime", "MinQueryTime", "MaxQueryDate", "MinQueryDate", "Sample Ratio"],
  //Boilerplate (internal non-business metric names), and Sample Ratio
  ALL_METRIC_CATEGORIES: ["Other Strong Movements", "Guardrail", "ProductWideImpact", "DataQuality", "Hypothesis"],
  ALL_METRIC_CATEGORIES_FRIENDLY: ["Other Strong Movements", "Guardrail", "Product-Wide Impact", "Data Quality", "Hypothesis"],
  OUTCOME_RED: "Red",
  OUTCOME_GREEN: "Green",
  OUTCOME_GREY: "Grey",
  ALERT_SAMPLE_RATIO_MISMATCH: "SampleRatioMismatch",
  ALERT_METRIC: "Metric",
  COLOR_OMITTED: "#323130",
  COLOR_UNDESIRED: "#810C06",
  COLOR_DESIRED: "#0E7878",
  COLOR_AMBIGUOUS: "#8764B8",
  COLOR_NOEFFECT: "#605E5C",
  MOVEMENTS: {
    IMPROVEMENT: "Improvement",
    REGRESSION: "Regression",
    AMBIGUOUS: "Ambiguous",
    NO_EFFECT: "No Effect"
  },
  TRAFFIC_FILTER_CONDITION: {
    CustomFilterOn: {
      simpleType: "Filtered",
      type: `'ImpressionFiltered'`,
      value: `'Yes'`
    },
    CustomTriggerOn: {
      simpleType: "Triggered",
      type: `'UserTriggered'`,
      value: `'Yes'`
    },
    CustomSessionTriggerOn: {
      simpleType: "Triggered",
      type: `'SessionTriggered'`,
      value: `'Yes'`
    },
    CustomTriggerComplementOn: {
      simpleType: "Triggered",
      type: `'UserTriggered'`,
      value: `'No'`
    }
  },
  TRAFFIC_FILTER_CONDITION_CUSTOM_WHERE: "CustomWhere",
  STEP_TYPE_SEEDFINDER: "SeedFinder",
  STEP_TYPE_AB: "AB",
  STEP_TYPE_EXTERNAL_AB: "ExternalAB",
  STEP_TYPE_INTERLEAVING: "Interleaving",
  SUMMARY_PIVOT_NAME: "summary",
  METRIC_MOVEMENT_DIRECTION: {
    OMITTED: "Omitted",
    REGRESSION: "Regression (p<0.05)",
    AMBIGUOUS: "Ambiguous effect (p<0.05)",
    NO_EFFECT: "No effect (p>0.05)",
    IMPROVEMENT: "Improvement (p<0.05)",
    STRONG_STAT_SIG: "*Indicates highly statistically significant (p<0.001)"
  },
  NEXT_ACTIONS: {
    STOP_OR_ITERATE_KEY: "stopOrIterate",
    STOP_OR_ITERATE_TEXT: "I want to stop or iterate this experiment",
    ADVANCE_KEY: "advance",
    ADVANCE_TEXT: "I want to advance this experiment",
    ANOTHER_SCORECARD_KEY: "anotherScorecard",
    ANOTHER_SCORECARD_TEXT: "I want to create another scorecard",
    NOT_SURE_KEY: "notSure",
    NOT_SURE_TEXT: "I’m not sure, show me recommended actions"
  },
  // To make the trustworthiness issues list short, we show 5 issues in exec summary page
  TRUSTWORTHINESS_ISSUES_COUNT: 5,
  METRIC_DISPLAY_LENGTH: 30
};
const METRIC_MOVEMENT_DIRECTIONS_MAP = [
  `${GarConstants.METRIC_MOVEMENT_DIRECTION.OMITTED}`,
  `${GarConstants.METRIC_MOVEMENT_DIRECTION.REGRESSION}`,
  `${GarConstants.METRIC_MOVEMENT_DIRECTION.REGRESSION}<br>${GarConstants.METRIC_MOVEMENT_DIRECTION.STRONG_STAT_SIG}`,
  `${GarConstants.METRIC_MOVEMENT_DIRECTION.AMBIGUOUS}`,
  `${GarConstants.METRIC_MOVEMENT_DIRECTION.AMBIGUOUS}<br>${GarConstants.METRIC_MOVEMENT_DIRECTION.STRONG_STAT_SIG}`,
  `${GarConstants.METRIC_MOVEMENT_DIRECTION.NO_EFFECT}`,
  `${GarConstants.METRIC_MOVEMENT_DIRECTION.IMPROVEMENT}`,
  `${GarConstants.METRIC_MOVEMENT_DIRECTION.IMPROVEMENT}<br>${GarConstants.METRIC_MOVEMENT_DIRECTION.STRONG_STAT_SIG}`
];
const RECOMMENDATIONS_MAP = {
  [GarConstants.OUTCOME_RED]: {
    value: "Concerning",
    icon: "Blocked2Solid",
    color: getTheme().palette.redDark,
    description: "Issues in these categories may necessitate stopping the experiment.",
    recommendationHeader: "Investigate these issues:"
  },
  [GarConstants.OUTCOME_GREEN]: {
    value: "Good",
    icon: "CompletedSolid",
    color: "#57A300",
    description: "These categories indicate a quality experiment and support advancing the feature.",
    recommendationHeader: "No action required:"
  },
  [GarConstants.OUTCOME_GREY]: {
    value: "Inconclusive",
    icon: "UnknownSolid",
    color: "#DB7500",
    description: "The signal in these categories is mixed or unclear.",
    recommendationHeader: "Manually review these issues:"
  }
};
var StepTypes = /* @__PURE__ */ ((StepTypes2) => {
  StepTypes2[StepTypes2["PREVIOUS"] = 0] = "PREVIOUS";
  StepTypes2[StepTypes2["CURRENT"] = 1] = "CURRENT";
  StepTypes2[StepTypes2["NEXT"] = 2] = "NEXT";
  return StepTypes2;
})(StepTypes || {});
const nextActionsOptions = [
  {
    key: GarConstants.NEXT_ACTIONS.STOP_OR_ITERATE_KEY,
    text: GarConstants.NEXT_ACTIONS.STOP_OR_ITERATE_TEXT
  },
  {
    key: GarConstants.NEXT_ACTIONS.ADVANCE_KEY,
    text: GarConstants.NEXT_ACTIONS.ADVANCE_TEXT
  },
  {
    key: GarConstants.NEXT_ACTIONS.ANOTHER_SCORECARD_KEY,
    text: GarConstants.NEXT_ACTIONS.ANOTHER_SCORECARD_TEXT
  },
  {
    key: GarConstants.NEXT_ACTIONS.NOT_SURE_KEY,
    text: GarConstants.NEXT_ACTIONS.NOT_SURE_TEXT
  }
];
export {
  METRIC_MOVEMENT_DIRECTIONS_MAP,
  RECOMMENDATIONS_MAP,
  StepTypes,
  GarConstants as default,
  nextActionsOptions
};
//# sourceMappingURL=GarConstants.js.map
